import { createReducer, on } from '@ngrx/store';
import { addItem, updateItem, getAllItems, deleteItem } from '../actions/app.actions';
import { User } from 'src/app/shared/models/user.model';

export const initialState: User[] = [new User('Johan','Zapata')];

const _appReducer = createReducer(initialState,
    on(addItem, (state, { name, last_name }) => [...state, new User(name, last_name)]),
    on(updateItem, (state, { user }) => state.map(users => {
        if (users.id != user.id) {
            return user;
        } else {
            return users;
        }
    })),
    on(getAllItems, (state) => state),
    on(deleteItem, (state, { id }) => state.filter(user => user.id != id)),
);

export function appReducer(state, action) {
    return _appReducer(state, action);
}